import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';

const GroupTitle = styled('h3')({
  margin: '0 0 8px 0',
  fontSize: '16px',
  fontWeight: '500'
});

const GroupDescription = styled('div')({
  color: '#333',
  fontSize: '14px',
  flex: 1,
  marginBottom: '35px',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: '1.5',
  maxHeight: '42px',
  cursor: 'default'
});

const ViewTalesButton = styled('div')({
  position: 'absolute',
  bottom: '20px',
  right: '20px',
  fontSize: '14px',
  fontWeight: '700',
  cursor: 'pointer'
});

const Group = ({ group, onInteraction }) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleViewTales = (e) => {
    e.stopPropagation();
    if (onInteraction && !onInteraction()) return;
    navigate(`/tales?group=${encodeURIComponent(group.name)}`);
  };

  return (
    <>
      <GroupTitle style={{ color: group.color || '#3498db' }}>
        {group.name}
      </GroupTitle>
      <Tooltip title={group.description} placement="top">
        <GroupDescription
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {group.description}
        </GroupDescription>
      </Tooltip>
      <ViewTalesButton
        onClick={handleViewTales}
        style={{ color: group.color || '#3498db' }}
      >
        View Tales
      </ViewTalesButton>
    </>
  );
};

export default Group;